import i18n, { TFunction } from "i18next";
import {
  initReactI18next,
  useTranslation as useI18nextTranslation,
} from "react-i18next";
import { useMemo } from "react";
import { useClient } from "@/hooks/useClient.ts";
import en from "@/i18n/locales/en.json";

// Keys suffixed with `_prizeCompetition` override the base key when the
// client has prize competition mode on, so no raffle wording is shown.
export const PRIZE_COMPETITION_CONTEXT = "prizeCompetition";

i18n.use(initReactI18next).init({
  resources: { en: { translation: en } },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes rendered values
  },
});

export const useTranslation = () => {
  const { t, i18n: instance } = useI18nextTranslation();
  const client = useClient();
  const context = client?.prize_competition_mode
    ? PRIZE_COMPETITION_CONTEXT
    : undefined;

  const translate = useMemo(
    () =>
      ((key: string, options?: object) =>
        t(
          key as never,
          { context, ...options } as never,
        )) as unknown as TFunction,
    [t, context],
  );

  return { t: translate, i18n: instance };
};

export default i18n;
